import { render } from "./reduction_positions.vue?vue&type=template&id=f687f5be&scoped=true"
import script from "./reduction_positions.vue?vue&type=script&lang=js"
export * from "./reduction_positions.vue?vue&type=script&lang=js"

import "./reduction_positions.vue?vue&type=style&index=0&id=f687f5be&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f687f5be"],['__file',"vue/js/components/sale/reduction/inside/fields/reduction_positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f687f5be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f687f5be', __exports__)) {
    console.log('reload')
    api.reload('f687f5be', __exports__)
  }
  
  module.hot.accept("./reduction_positions.vue?vue&type=template&id=f687f5be&scoped=true", () => {
    console.log('re-render')
    api.rerender('f687f5be', render)
  })

}


export default __exports__